<template>
  <div>
    <TradingModal :open="showTrading" @closed="closeTrading" />
    <Disclosure as="nav" class="bg-primary-700" v-slot="{ open }">
      <div class="mx-auto max-w-7xl px-6">
        <div class="flex h-16 items-center justify-between">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <NuxtLink :to="'/'+lang+'/dashboard'" class="flex flex-row"><img class="h-10 cursor-pointer" src="~/assets/img/logo/logo_contrast.png" alt="" />
                <!--<div class="text-primary-400 ml-2 text-xs">BETA</div>-->
              </NuxtLink>
            </div>
            <!--
            <div class="hidden md:block">
              <div class="ml-10 flex items-baseline space-x-4">
                <a v-for="item in navigation" :key="item.name" @click="item.action"
                  :class="[item.current ? 'bg-primary-800 text-white' : 'text-white hover:bg-primary-500 hover:bg-opacity-75', 'px-3 py-2 rounded-md text-sm font-medium cursor-pointer']"
                  :aria-current="item.current ? 'page' : undefined">
                  {{ item.name }}

                </a>
                <Menu as="div" class="relative inline-block text-left" v-if="isVerified">
                  <div>
                    <MenuButton
                      class="text-white hover:bg-primary-500 hover:bg-opacity-75 px-3 py-2 rounded-md text-sm font-medium flex items-center">
                      {{ $t('actions') }}
                      <ChevronDownIcon class="-mr-1 ml-1 h-3 w-3" aria-hidden="true" />
                    </MenuButton>
                  </div>

                  <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">
                    <MenuItems
                      class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div class="py-1">
                        <MenuItem v-slot="{ active }">
                        <NuxtLink :to="'/'+lang+'/trading/buy'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_purchase.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('buy_assets') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/sell'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('sell_assets') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/delivery'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_delivery.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('gold_delivery') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>
                      <div class="py-1">

                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/transfer'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('asset_transfer') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>

                    </MenuItems>
                  </transition>
                </Menu>
                <Menu as="div" class="relative inline-block text-left" v-if="doesHaveEtfAccess">
                  <div>
                    <MenuButton
                      class="text-white hover:bg-blue-500 hover:bg-opacity-75 px-3 py-2 rounded-md text-sm font-medium flex">
                      {{ $t('ETF') }}
                      <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                    </MenuButton>
                  </div>
                  <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95" >
                    <MenuItems
                      class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" v-if="isUpvestAccountActive">
                      <div class="py-1">
                        <MenuItem v-slot="{ active }">
                        <NuxtLink :to="'/'+lang+'/cash-balance'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_purchase.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('manageCashBalance') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/etf-transaction-history'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('transactionHistory') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/upvest-account-history'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_delivery.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('accountHistory') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>
                      <div class="py-1">

                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/instruments/tax-exemption'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('TAX_EXEMPTION_CREATION') }}
                          </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/security-legal-document'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('legalDocuments') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>

                    </MenuItems>
                    <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" v-else>
                      <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/upvest-activate'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          
                          {{ $t('activateUpvestAccount') }}
                          </NuxtLink>
                        </MenuItem>
                    </MenuItems>
                  </transition>
                  
                </Menu>
              </div>
            </div>
            -->
          </div>
          <div class="hidden md:flex items-center">
            <div @click="gotoInboxMessage" class="flex -hover:bg-primary-500 hover:bg-opacity-75 relative rounded-full bg-primary-700 p-2 text-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600 cursor-pointer">
                <span v-if="newInboxMessageCount" class="absolute bottom-[6px] left-[27px] h-2 w-2 flex items-center justify-center bg-red-500 rounded-full text-white text-[10px] font-bold">
                  <!--{{ newInboxMessageCount }}-->
                </span>
                <InboxIcon class="h-6 w-6" aria-hidden="true" />
                <span class="ml-2">Inbox</span>
              </div>
              <div @click="gotoSupport" class="flex -hover:bg-primary-500 hover:bg-opacity-75 cursor-pointer relative rounded-full bg-primary-700 p-2 ml-3 text-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600">
                  <!--
                  <span v-if="newSupportTicketAnswerCount" class="absolute top-[-10px] right-[-2px] h-4 w-4 text-[10px] text-primary-700 text-center rounded-full bg-white ">
                    {{ newSupportTicketAnswerCount }}
                  </span>
                  -->
                <span v-if="newSupportTicketAnswerCount" class="absolute bottom-[6px] left-[27px] h-2 w-2 flex items-center justify-center bg-red-500 rounded-full text-white text-[10px] font-bold">
                    <!-- {{ newSupportTicketAnswerCount }} -->
                  </span>
                  <ChatBubbleLeftEllipsisIcon class="h-6 w-6" aria-hidden="true" />
                  <span class="ml-2">Support</span>
                </div>
                <Menu as="div" class="relative ml-5">
                  <div>
                    <MenuButton class="flex max-w-xs items-center rounded-full bg-primary-600 text-sm focus:outline-none focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600">
                      <span class="sr-only">Open user menu</span>
                      <img v-if="updatedAvatar || avatar || defaultAvatar" class="h-9 w-9 rounded-full" :src="updatedAvatar || avatar || defaultAvatar" alt="" />
                      <div v-else class="h-8 w-8 rounded-full"><Loading/></div>
                    </MenuButton>
                  </div>
                  <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                    <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                        <a @click="item.action" class="cursor-pointer" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{ item.name }}</a>
                      </MenuItem>
                    </MenuItems>
                  </transition>
                </Menu>
          </div>
          <div class="-mr-2 flex md:hidden">
            <!-- Mobile menu button -->
            <!--
              <Menu as="div" class="relative inline-block text-left" v-if="isVerified">

                  <div>
                    <MenuButton
                      class="text-white bg-primary-600 hover:bg-primary-500 hover:bg-opacity-75 px-3 py-3 rounded-md text-sm font-medium flex mr-3">
                      <PlusIcon class=" mr-1 h-5 w-5" aria-hidden="true" />
                      {{ $t('actions') }}

                    </MenuButton>
                  </div>

                  <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">
                    <MenuItems
                      class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div class="py-1">
                        <MenuItem v-slot="{ active }">
                        <NuxtLink :to="'/'+lang+'/trading/buy'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_purchase.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('buy_assets') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/sell'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('sell_assets') }}
                        </NuxtLink>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/delivery'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_delivery.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('gold_delivery') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>
                      <div class="py-1">

                        <MenuItem v-slot="{ active }">
                          <NuxtLink :to="'/'+lang+'/trading/transfer'"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                          <img src="./../assets/img/icons/gold_sell.png" class="h-5 w-5 flex-shrink-0 rounded-full bg-gray-300 mr-2"/>
                          {{ $t('asset_transfer') }}
                          </NuxtLink>
                        </MenuItem>
                      </div>

                    </MenuItems>
                  </transition>
                </Menu>
              -->
            <DisclosureButton
              class="inline-flex items-center justify-center rounded-md bg-primary-600 p-2 text-primary-200 hover:bg-primary-500 hover:bg-opacity-75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600">
              <span class="sr-only">Open main menu</span>
              <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
              <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
            </DisclosureButton>
          </div>
        </div>
      </div>


      <DisclosurePanel class="md:hidden">
        <!--
        <div class="space-y-1 px-2 pt-2 pb-3 sm:px-3">
          <DisclosureButton v-for="item in navigation" :key="item.name" as="a" :href="item.href"
            :class="[item.current ? 'bg-primary-900 text-white' : 'text-white hover:bg-primary-500 hover:bg-opacity-75', 'block px-3 py-2 rounded-md text-base font-medium cursor-pointer']"
            :aria-current="item.current ? 'page' : undefined">{{ item.name }}</DisclosureButton>

        </div>
        -->

        <div class="border-t border-primary-700 pt-4 pb-3">
          <div class="flex items-center justify-between px-5">
            <div class="flex">
              <div class="flex-shrink-0">
              <img class="h-10 w-10 rounded-full" :src="avatar" alt="" />
              </div>
              <div class="ml-3">
                <div class="text-base font-medium text-white">{{ name }}</div>
                <div class="text-sm font-medium text-primary-300">{{ email }}</div>
              </div>
            </div>
            <div class="flex gap-2">
            <button @click="gotoInboxMessage" type="button"
              class="relative ml-auto flex-shrink-0 rounded-full bg-primary-600 p-1 text-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600">
              <span class="sr-only">View Inbox Messages</span>
              <span v-if="newInboxMessageCount"
                class="absolute top-[-10px] right-[-4px] h-4 w-4 text-[10px] text-primary-700 rounded-full bg-white text-center">
                {{ newInboxMessageCount }}
              </span>
              <InboxIcon class="h-6 w-6" aria-hidden="true" />
            </button>
            <button @click="gotoSupport" type="button"
              class="relative ml-auto flex-shrink-0 rounded-full bg-primary-600 p-1 text-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600">
              <span class="sr-only">View Support Tickets</span>
              <span v-if="newSupportTicketAnswerCount"
                class="absolute top-[-10px] right-[-4px] h-4 w-4 text-[10px] text-primary-700 rounded-full bg-white text-center">
                {{ newSupportTicketAnswerCount }}
              </span>
              <span class="sr-only">View Support Messages</span>
              <ChatBubbleLeftEllipsisIcon class="h-6 w-6" aria-hidden="true" />
            </button>
            </div>
          </div>
          <div class="mt-3 space-y-1 px-2">
            <DisclosureButton v-for="item in userNavigation" :key="item.name" as="a" @click.prevent="item.action"
              class="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-primary-500 hover:bg-opacity-75 cursor-pointer">
              {{ item.name }}
            </DisclosureButton>
          </div>
        </div>

      </DisclosurePanel>

    </Disclosure>

    <!--
    <div v-if="runTimeApp==appNames.getGreenGold">

    </div>
    <div v-else>

    </div>
    -->

    <main>
      <!--<div class="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">-->
        <!-- Replace with your content -->
        <!--<div class="px-4 py-4 sm:px-0">-->
          <slot />
        <!--</div>-->
        <!-- /End replace -->
      <!--</div>-->
    </main>

  </div>
</template>
  
  <script setup lang="ts">
  import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
  import { Bars3Icon, XMarkIcon,ChevronDownIcon, InboxIcon, ChatBubbleLeftEllipsisIcon } from '@heroicons/vue/24/outline';
  import { PlusIcon } from '@heroicons/vue/20/solid'
  import Footer from '@/components/Footer.vue';
  import Loading from '@/components/common/Loading.vue';
import { Account,UpvestAccount } from '~~/lib/models/Account';
import { computed,onMounted,Ref,provide } from 'vue';
import { AccountService } from '~~/lib/services/AccountService';
import { AccountStorage } from '~~/storage/AccountStorage';
import TradingModal from '@/components/TradingModal';
import LogoutHelper from '~~/helpers/LogoutHelper';
import defaultAvatar from '@/assets/img/defaultAvatar.png';
  import {appNames} from "~/lib/appNames";
import { UpvestAccountStatuses } from '~/lib/contants';
const user:Ref<Account>= ref(null);
const upvestAccount:Ref<UpvestAccount> = ref(null);
const updatedAvatar = ref();
const {t,locale} = useI18n();
const router = useRouter();
const currentPage = ref(1);
useHead({
  htmlAttrs: {
    class: 'h-full bg-gray-50'
  },
  bodyAttrs: {
    class: 'h-full align-middle'
  }
})
onMounted(async () => {
  const account = AccountStorage.getAccount();
  upvestAccount.value = AccountStorage.getUpvestAccount();
  if (account) {
    user.value = account;
  }
  else {
    const contactId = AccountStorage.getContactId();
    user.value = await AccountService.getAccount(parseInt(contactId));
  }

})
const isVerified = computed(() => {
  if (user.value) {
    return user.value.is_verified;
  }
  else {
    return false;
  }
})
const doesHaveEtfAccess = computed(() => {
  if (user.value) {
    return user.value.account.is_trading_available;
  }
  else {
    return false;
  }
})
const isUpvestAccountActive = computed(() => {
  if (upvestAccount.value) {
    return upvestAccount.value?.status == UpvestAccountStatuses.active
  }
  else {
    return false;
  }
})
const route = router.currentRoute.value.name?.toString();
const lang = computed(()=>{
  return locale.value
})
const pageName = computed(() => {
  if (route?.includes('depot-detail')) {
    return 'depot_detail'
  }
  return 'dashboard'
})
const isDashboard = computed(() => {
  return (route?.includes('dashboard'));
})
const newInboxMessageCount = computed(() => {
  if (user.value?.account?.new_inbox_message_count) {
    return user.value.account.new_inbox_message_count
  }
  return 0
})
const newSupportTicketAnswerCount  = computed(()=>{
    if(user.value?.account?.new_support_ticket_answer_count){
      return user.value.account.new_support_ticket_answer_count
    }
    return 0
  })
const showTrading = ref(false);
const openTrading = () => {
  showTrading.value = true;
}
const closeTrading = () => {
  showTrading.value = false;
}
const avatar = computed(() => {
  let avatar = '';
  if (user && user.value && user.value.avatar) {
    avatar = user.value.avatar;
  }
  return avatar;
})
const email = computed(() => {
  let email = "";
  if (user.value) {
    user.value.channels.forEach(channel => {
      if (channel.type.value == "email") {
        email = channel.value;
      }
    })
  }
  return email;
})
const name = computed(() => {
  let name = "";
  if (user.value) {
    name = user.value.name;
    if (user.value.person_data) {
      if(user.value.person_data.middlename!=null && user.value.person_data.middlename!="" ){
        name += ' '+ user.value.person_data.middlename;
      }
      name += ' '+ user.value.person_data.surname;
    }
  }
  return name;
})
const navigation = [
  {
    name: t('dashboard'), action: () => {
      const url = window.location.origin + '/' + locale.value + '/dashboard';
      window.open(url, '_self');
    }, current: false
  },
]
const userNavigation = [
  {
    name: t('your_profile'), action: () => {
      router.push("/" + locale.value + '/profile')
    }
  },
  
  {
    name: t('sign_out'), action: () => {
      LogoutHelper(router);
    } },
  ]
  const gotoInboxMessage = ()=> {
    const url = '/' + locale.value + '/inbox-message';
    router.push(url)
  }
  const gotoSupport = ()=> {
    const url = '/' + locale.value + '/support-tickets';
    router.push(url)
  }
  const updateProfileAvatarProvider =(account: Account)=> {
    updatedAvatar.value = account.avatar
  }
  provide('updateProfileAvatarProvider', updateProfileAvatarProvider);
  </script>
